import { User } from '@/domain/entities/user/user'
import { UserRegistrationRequest } from '@/domain/entities/user/userCreateRequest'
import { AuthRepository } from '@/domain/repositories/auth/AuthRepository'
import { ApiClients } from '@/infrastructure/clients/apiClients'
import { userDecoder } from '@/infrastructure/decoders/user/userDecoder'

export class AuthRepositoryImpl implements AuthRepository {
  constructor(private clients: ApiClients) {}

  async checkSession(): Promise<User> {
    const path = `self`
    const data = await this.clients.aojClient.fetchAndDecode(userDecoder, path)
    return data
  }

  async login(id: string, password: string): Promise<User> {
    const path = `session`
    const data = await this.clients.aojClient.fetchAndDecode(userDecoder, path, {
      method: 'POST',
      body: JSON.stringify({ id, password })
    })
    return data
  }

  async logout(): Promise<void> {
    const path = `session`
    await this.clients.aojClient.post(path, {
      method: 'DELETE'
    })
  }

  async registerUser(user: UserRegistrationRequest): Promise<void> {
    const path = `users`
    await this.clients.aojClient.fetch(path, {
      method: 'POST',
      body: JSON.stringify(user)
    })
  }
}
